export interface IAnalyticsPeriod {
    period_start: string;
    period_end: string;
}